import React, { useEffect, useState } from 'react';
import { ButtonUI, DialogUI, FileTabUI, FileUploadUI } from '../Interface';
import { Box } from '@mui/material';
import simpletaskService from '../../service/simpletask.service';

const SimpleTaskAttachmentDialog = ({ dialogData, handleClose, setRefetch }) => {
  const { open, attachments, simpleTaskId } = dialogData;
  const [filesToUpload, setFilesToUpload] = useState([]);

  const handleUpload = () => {
    const formData = new FormData();

    for (const file of filesToUpload) {
      formData.append('files', file.file);
    }

    simpletaskService.uploadSimpleTaskAttachments(formData, simpleTaskId).then(() => {
      setFilesToUpload([]);
      setRefetch(true);
      handleClose();
    });
  };

  const handleFilesChange = (newFiles) => {
    setFilesToUpload(newFiles);
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Csatolmányok"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
            mx: 1,
            height: '90vh',
          },
        },
        '& .MuiDialogContent-root': {
          px: 1,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box minHeight={0}>
        <FileUploadUI onFilesChange={handleFilesChange} />
        <Box mt="1rem">
          <FileTabUI savedFiles={attachments ?? []} />
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          gap={3}
          alignItems="center"
          position="sticky"
          bottom={0}
          backgroundColor="#fff"
          zIndex={10}
          mt="1rem"
        >
          <ButtonUI
            text="Feltöltés"
            className="bg-success flex gap-2 items-center"
            type="button"
            disabled={!filesToUpload?.length > 0}
            onClick={handleUpload}
          />
          <ButtonUI
            text="Mégse"
            className="bg-danger flex items-center gap-2"
            type="button"
            onClick={() => handleClose()}
          >
            Bezárás
          </ButtonUI>
        </Box>
      </Box>
    </DialogUI>
  );
};

export default SimpleTaskAttachmentDialog;
